import { Menu } from "@snpjs/core";

// import { DownloadSoftwareBundleMenuItem } from "../../downloadSoftwareBundle/DownloadSoftwareBundleMenuItem";
import { IInstallGuideMenuProps } from "./IInstallGuideMenuProps";
import { InstallGuideMenuItem } from "../installGuideMenuItem/installGuideMenu/InstallGuideMenuItem";

export const InstallGuideMenu: React.FC<IInstallGuideMenuProps> = (props) => {
  return (
    <>
      <Menu>
        <InstallGuideMenuItem
          objectId={props.objectId}
          checksumSha1={props.checksumSha1}
        />
        {/* <MenuDivider />
        <DownloadSoftwareBundleMenuItem
          objectId={props.objectId}
          checksumSha1={props.checksumSha1}
        /> */}
      </Menu>
    </>
  );
};
